module.exports = __webpack_public_path__ + "/images/cover-acompanamos-embarazo-it.d218267.webp";